import React from "react";

import { Button, Form, Input } from "semantic-ui-react";

import { useIntl } from "react-intl";

type SettingOAAccountFormBasicProps = {
  data: Record<string, any>;
  isLoading: boolean;
  onChangeValue: (e: any, data: any) => void;
  onSubmit: () => void;
};

const SettingOAAccountFormBasic: React.FC<SettingOAAccountFormBasicProps> = (props) => {
  const intl = useIntl();

  return (
    <div className="profile-info" style={{ borderLeft: 0, marginBottom: "3rem" }}>
      <Form>
        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "ชื่อบัญชี" })}</label>
          <Input
            className="reg"
            disabled={props.isLoading}
            name="name"
            placeholder={intl.formatMessage({ id: "แผนกอายุรกรรม" })}
            value={props.data.name || ""}
            onChange={props.onChangeValue}
          />
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "โรงพยาบาล/องค์กร" })}</label>
          <Input
            className="reg"
            disabled={props.isLoading}
            name="hospital_name"
            value={props.data.hospital_name || ""}
            onChange={props.onChangeValue}
          />
        </Form.Field>

        <Form.Field className="agency-code">
          <div>
            <label className="reg" style={{ fontWeight: "bold" }}>
              {intl.formatMessage({ id: "รหัสหน่วยงาน" })}
            </label>
            <Input
              className="reg"
              disabled={props.isLoading}
              name="code"
              value={props.data.code || ""}
              fluid
              onChange={props.onChangeValue}
            />
            <label className="reg">*รหัสมาตราฐาน 5 หลัก</label>
          </div>
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "ชื่อระบบที่ใช้งาน" })}</label>
          <Input
            className="reg"
            disabled={props.isLoading}
            name="system_name"
            value={props.data.system_name || ""}
            onChange={props.onChangeValue}
          />
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "สถานะการรับรอง" })}</label>
          {props.data.verified ? (
            <label
              style={{
                color: "green",
                fontSize: "15px",
                marginLeft: "5px",
                marginRight: "10px",
              }}
            >
              verify
            </label>
          ) : (
            <label
              style={{
                color: "red",
                fontSize: "15px",
                marginLeft: "5px",
                marginRight: "10px",
              }}
            >
              Unverify
            </label>
          )}
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "ตำแหน่งที่ตั้ง" })}</label>
          <Input
            className="reg"
            disabled={props.isLoading}
            icon="map marker alternate"
            value={props.data.address || ""}
            onChange={props.onChangeValue}
          />
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "เบสิค URL" })}</label>
          <Input className="reg" value={props.data.account_link} readOnly />
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "พรีเมียม URL" })}</label>
          <Input
            className="reg"
            disabled={props.isLoading}
            value={props.data.premium_url || ""}
            onChange={props.onChangeValue}
          />
          <Button
            className="btn-green"
            disabled={props.isLoading}
            // onClick={(e) => {
            //   // Handle premium ID purchase
            // }}
          >
            ซื้อพรีเมียม ID
          </Button>
        </Form.Field>

        <Form.Field inline>
          <label className="reg">{intl.formatMessage({ id: "แพ็กเกจ" })}</label>
          <Input className="reg" placeholder="Free trial" readOnly />
          <Button
            className="btn-green"
            disabled={props.isLoading}
            // onClick={(e) => {
            //   // Handle package change
            // }}
          >
            เปลี่ยนแพ็กเกจ
          </Button>
        </Form.Field>
      </Form>

      <br />

      <div className="last-div" style={{ margin: "20px 0 0 260px", paddingLeft: 0 }}>
        <Button
          style={{ backgroundColor: "var(--primary-theme-color)", color: "white" }}
          disabled={props.isLoading}
          loading={props.isLoading}
          type="submit"
          onClick={props.onSubmit}
        >
          บันทึกการแก้ไข
        </Button>
      </div>
    </div>
  );
};

export default SettingOAAccountFormBasic;
